<template>
    <Empty description="暂无数据" v-if="List.length===0" />
    <List v-else class="coin-record"  v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad">

       <div class="coin-record-body">
           <template v-for="(item,index) in List">
               <template v-if="index==0 || item.month!=List[index-1]['month']">
                   <div class="coin-record-body-title">{{item.curMounth}}</div>
               </template>
               <Cell
                       :title="item.description"
                       :key="index"
                       :icon="item.icon"
                       :label="item.recorddate"
               >
                   <img :src="item.icon" alt="" slot="icon">
                   <span :style="{color:item.value*1<0?'#0B9851':'#F93934'}" class="aaa" slot="default">
                    <span v-if="item.value>0">+</span>
                    {{item.value}}
                </span>
               </Cell>
           </template>
       </div>

    </List>
    

</template>
<script>
    import {Cell,List,Empty} from 'vant'
    import './index.less'

    export default {
        name: "coinRecord",
        components: {
            Cell,
            List,
            Empty
        },
        data() {
            return {
                page:1,
                List: [],
                finished:false,
                loading:false
            }
        },
        methods: {
            onLoad(e){
              this.getList()
            },
            getList() {
                if(this.finished) return;
                this.$api.user.getPoints({page:this.page}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.List = this.List.concat(res.data.list)
                        if(res.data.pages*1>this.page){
                            this.page++
                        }else{
                            this.finished   =   true
                        }
                    }
                    this.loading = false
                })
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.getList();
            })
        }
    }
</script>
